import React, { Component } from "react";
import ReactDom from "react-dom";
import PropTypes from "prop-types";

const modalRoot = document.getElementById("modal-root");

class ModalSearch extends Component {
  static defaultProps = {
    id: "",
    modalClass: "",
    modalSize: "md",
    backgroundColor: "#fff",
  };

  static propTypes = {
    id: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    modalClass: PropTypes.string,
    modalSize: PropTypes.string,
    modalHeight: PropTypes.string,
    backgroundColor: PropTypes.string,
    children: PropTypes.node,
  };

  state = { fadeType: null };
  background = React.createRef();

  componentDidMount() {
    window.addEventListener("keydown", this.onEscKeyDown, false);
    // Trigger start animation
    setTimeout(() => this.setState({ fadeType: "in" }), 0);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen !== prevProps.isOpen) {
      this.setState({ fadeType: "out" });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.onEscKeyDown, false);
  }

  transitionEnd = (e) => {
    if (e.propertyName !== "opacity" || this.state.fadeType === "in") return;

    if (this.state.fadeType === "out") {
      this.props.onClose();
    }
  };

  onEscKeyDown = (e) => {
    if (e.key !== "Escape") return;
    this.setState({ fadeType: "out" });
  };

  handleClick = (e) => {
    e.preventDefault();
    this.setState({ fadeType: "out" });
  };

  render() {
    // Prevent crash if modalRoot isn't found
    if (!modalRoot) return null;

    // --- Dynamic Styles Calculation ---

    // 1. Wrapper Styles (Opacity handling)
    const wrapperStyle = {
      ...styles.wrapper,
      opacity: this.state.fadeType === "in" ? 1 : 0,
    };

    // 2. Dialog Box Styles (Background color handling)
    const boxDialogStyle = {
      ...styles.boxDialog,
      backgroundColor: this.props.backgroundColor,
    };

    return ReactDom.createPortal(
      <div
        id={this.props.id}
        className={`wrapper ${"size-" + this.props.modalSize} ${
          this.props.modalClass
        }`}
        role="dialog"
        style={wrapperStyle}
        onTransitionEnd={this.transitionEnd}
      >
        <div className="box-dialog" style={boxDialogStyle}>
          <div className="box-content" style={styles.boxContent}>
            {this.props.children}
          </div>
        </div>

        <div
          className="background"
          style={styles.background}
          onMouseDown={this.handleClick}
          ref={this.background}
        />
      </div>,
      modalRoot,
    );
  }
}

// --- CSS Objects ---

const styles = {
  wrapper: {
    position: "fixed",
    top: "5px",
    right: "5px",
    width: "550px",
    maxWidth: "calc(100vw - 10px)",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    zIndex: 2000,
    margin: "auto",
    // Transition settings
    transition: "opacity 0.1s",
    WebkitTransition: "opacity 0.1s",
    MozTransition: "opacity 0.1s",
    OTransition: "opacity 0.1s",
  },
  background: {
    background: "#2064a12e",
    position: "fixed",
    zIndex: 1040,
    display: "block",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    outline: 0,
  },
  boxDialog: {
    borderRadius: "15px",
    zIndex: 1050,
    width: "100%",
    boxShadow: "0px 0px 3px 3px rgba(0, 0, 0, 0.071)",
    // Background color is handled dynamically in render
  },
  // Corresponds to the nested .box-body styles in your original CSS
  boxContent: {
    padding: "15px",
    // maxHeight: "calc(100vh - 270px)",
    overflowY: "auto",
    overflowX: "auto",
  },
};

export default ModalSearch;
